<template>
<!-- ====================== 페이지내 내용 ====================== 
-->
<div>
    <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >
        <v-toolbar-title
        v-if="queryAppId"
        >DAY7 광고수정</v-toolbar-title>
        <v-toolbar-title
        v-else
        >DAY7 광고등록</v-toolbar-title>
        <v-spacer/>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= ""
            >mdi-information-variant</v-icon>
        </v-btn>
    </template>
    등록 버튼은 게임명, 패키지, 버전이 입력되어야 활성화됨니다. 이미지의 업로드와 삭제는 수정,등록 버튼을 누르지 않아도 동작됩니다.
    </v-tooltip>
    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <form
            class="pa-4">
            <v-switch
              class="mb-5"
              v-model="appUseFlag"
              label="게시"
              false-value="N"
              true-value="Y"
              color="red darken-3"
              value="red darken-3"
              hide-details
            ></v-switch>
            <v-row>
                <v-col
                    cols="6">
            <v-text-field
            v-model="appName"
            label="게임명"
            required
            filled
            outlined
            dense
            ></v-text-field>
                </v-col>
                <v-col
                    cols="6">
            <v-text-field
            v-model="appPackage"
            label="패키지"
            required
            filled
            outlined
            dense
            ></v-text-field>
                </v-col>
                <v-col
                    cols="6">
            <v-text-field
            v-model="selected_ad_os"
            label="OS"
            required
            filled
            outlined
            dense
            :disabled="true"
            ></v-text-field>
                </v-col>
                <v-col
                    cols="6">
            <v-text-field
            v-model="appVersion"
            label="버전"
            required
            filled
            outlined
            dense
            ></v-text-field>
                </v-col>
                <v-col
                    v-show="selected_ad_os == 'IOS'"
                    cols="6">
            <v-text-field
            v-model="appAppleId"
            label="Apple ID"
            required
            filled
            outlined
            dense
            ></v-text-field>
                </v-col>
                <v-col
                    v-show="selected_ad_os == 'IOS'"
                    cols="6">
            <v-text-field
            v-model="urlSchemes"
            label="URL 스키마"
            required
            filled
            outlined
            dense
            ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="2">
                    <v-switch
                    class="mt-1"
                    v-model="appCustomLink"
                    label="커스텀 url 사용"
                    color="red darken-3"
                    false-value="N" 
                    true-value="Y"
                    hide-details
                    ></v-switch>
                </v-col>
                <v-col
                    cols="4">
                    <v-text-field
                    v-model="appCustomUrl"
                    v-show="appCustomLink == 'Y'"
                    label="커스텀 url"
                    required
                    filled
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="2">
                    <v-switch
                    v-model="appReservation"
                    class="mt-1"
                    label="사전예약중"
                    color="red darken-3"
                    false-value="N" 
                    true-value="Y"
                    hide-details
                    ></v-switch>
                </v-col>
                <v-col
                    cols="4">
                    <v-text-field
                    v-model="appReservationUrl"
                    v-show="appReservation == 'Y'"
                    label="사전예약 url"
                    required
                    filled
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-divider 
                class="my-4"
                v-show="appNotice == 'Y'"
            ></v-divider>
            <v-row>
                <v-col
                    cols="2">
                    <v-switch
                    v-model="appNotice"
                    class="mt-1"
                    label="공지사항"
                    color="red darken-3"
                    value="red darken-3"
                    hide-details
                    false-value="N" 
                    true-value="Y"
                    ></v-switch>
                </v-col>
                <v-col
                    v-show="appNotice == 'Y'"
                    class="py-0">
                    <v-row>
                        <v-col
                            cols="7">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date"
                                    label="시작일 선택"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    filled
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="date"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    취소
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(date)"
                                >
                                    확인
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="5">
                            <v-menu
                                ref="menut1"
                                v-model="menut1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time1"
                                    label="시작 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    filled
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut1"
                                v-model="time1"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut1.save(time1)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            cols="7">
                            <v-menu
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                :return-value.sync="date2"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date2"
                                    label="종료일 선택"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    filled
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="date2"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu2 = false"
                                >
                                    취소
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu2.save(date2)"
                                >
                                    확인
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="5">
                            <v-menu
                                ref="menut2"
                                v-model="menut2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time2"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time2"
                                    label="종료 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    filled
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut2"
                                v-model="time2"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut2.save(time2)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col
                    v-show="appNotice == 'Y'"
                    cols="6">
                    <div
                        class="d-flex flex-row align-center">
                        <v-file-input
                            v-model="files.appNoticeFileId"
                            :disabled="noticeFilePath != null"
                            :rules="rules"
                            accept="image/png, image/jpeg, image/bmp"
                            placeholder="공지사항 이미지 파일을 선택하여 주십시오"
                            prepend-icon="mdi-file-image"
                            label="공지"
                        ></v-file-input>
                            <v-btn
                                small
                                :disabled="noticeFilePath != null || files.appNoticeFileId == null"
                                color="blue"
                                @click="clickUploadImageBtn('appNoticeFileId')"
                                class="ml-3">
                                업로드
                            </v-btn>
                            <v-btn
                                small
                                :disabled="noticeFilePath == null"
                                color="red"
                                @click="clickDeleteImageBtn('appNoticeFileId')"
                                class="ml-3">
                                삭제
                            </v-btn>
                    </div>
                    <v-card
                        outlined
                        height="200"
                        class="d-flex justify-center align-center"
                        >
                            <v-hover
                                v-if="noticeFilePath != null"
                            >
                            <img
                            full
                            :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + noticeFilePath.replace('files/', '/')" class="mt-2 mb-2" style="height: 180px">
                            </v-hover>                            
                            <div
                            v-else>
                                등록된 이미지가 없습니다.
                            </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-divider class="my-4" ></v-divider>
            <v-row>
                <v-col>
                    <!-- 개발시 테스트를 위해서, 업로드 버튼과 삭제 버튼 그리고 파일선택창을 항상 활성화시켰다. -->
                    <div
                        class="d-flex flex-row align-center">
                        <v-file-input
                            v-model="files.appIconFileId"
                            :disabled="iconFilePath != null"
                            :rules="rules"
                            accept="image/png, image/jpeg, image/bmp"
                            placeholder="아이콘 이미지 파일을 선택하여 주십시오"
                            prepend-icon="mdi-file-image"
                            label="아이콘"
                        ></v-file-input>
                            <v-btn
                                small
                                :disabled="iconFilePath != null || files.appIconFileId == null"
                                color="blue"
                                @click="clickUploadImageBtn('appIconFileId')"
                                class="ml-3">
                                업로드
                            </v-btn>
                            <v-btn
                                small
                                :disabled="iconFilePath == null"
                                color="red"
                                @click="clickDeleteImageBtn('appIconFileId')"
                                class="ml-3">
                                삭제
                            </v-btn>
                    </div>
                        <v-hover
                            v-slot="{ hover }"
                            :disabled="iconFilePath == null"
                        >
                            <v-card
                                :class="{ 'on-hover': hover }"
                                :elevation="hover ? 10 : 0"
                                outlined
                                height="200"
                                class="d-flex justify-center align-center"
                                @click="clickIconImage"
                                >
                                    <img
                                    v-if="iconFilePath != null"
                                    full
                                    :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + iconFilePath.replace('files/', '/')" class="mt-2 mb-2" style="height: 180px">
                                    
                                    <div
                                    v-else>
                                        등록된 이미지가 없습니다.
                                    </div>   
                            </v-card>
                        </v-hover>
                </v-col>
                <v-col>
                    <div
                        class="d-flex flex-row align-center">
                        <v-file-input
                            :rules="rules"
                            v-model="files.appGraphicFileId"
                            :disabled="graphicFilePath != null"
                            accept="image/png, image/jpeg, image/bmp"
                            placeholder="그래픽 이미지 파일을 선택하여 주십시오"
                            prepend-icon="mdi-file-image"
                            label="그래픽 이미지"
                        ></v-file-input>
                            <v-btn
                                small
                                :disabled="graphicFilePath != null || files.appGraphicFileId == null"
                                color="blue"
                                @click="clickUploadImageBtn('appGraphicFileId')"
                                class="ml-3">
                                업로드
                            </v-btn>
                            <v-btn
                                small
                                :disabled="graphicFilePath == null"
                                color="red"
                                @click="clickDeleteImageBtn('appGraphicFileId')"
                                class="ml-3">
                                삭제
                            </v-btn>
                    </div>
                        <v-hover
                            v-slot="{ hover }"
                            :disabled="graphicFilePath == null"
                        >
                            <v-card
                                :class="{ 'on-hover': hover }"
                                :elevation="hover ? 10 : 0"
                                outlined
                                height="200"
                                class="d-flex justify-center align-center"
                                @click="clickgraphicImage"
                                >
                                    <img
                                    v-if="graphicFilePath != null"
                                    full
                                    :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + graphicFilePath.replace('files/', '/')" class="mt-2 mb-2" style="height: 180px">
                                    
                                    <div
                                    v-else>
                                        등록된 이미지가 없습니다.
                                    </div>   
                            </v-card>
                        </v-hover>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <div
                        class="d-flex flex-row align-center">
                            <v-file-input
                                :rules="rules"
                                v-model="files.appPortraitFileId"
                                :disabled="portraitFilePath != null"
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="세로광고 이미지 파일을 선택하여 주십시오"
                                prepend-icon="mdi-file-image"
                                label="세로광고(전면/중간)"
                            ></v-file-input>
                            <v-btn
                                small
                                :disabled="portraitFilePath != null || files.appPortraitFileId == null"
                                color="blue"
                                @click="clickUploadImageBtn('appPortraitFileId')"
                                class="ml-3">
                                업로드
                            </v-btn>
                            <v-btn
                                small
                                :disabled="portraitFilePath == null"
                                color="red"
                                @click="clickDeleteImageBtn('appPortraitFileId')"
                                class="ml-3">
                                삭제
                            </v-btn>
                    </div>
                        <v-hover
                            v-slot="{ hover }"
                            :disabled="portraitFilePath == null"
                        >
                            <v-card
                                :class="{ 'on-hover': hover }"
                                :elevation="hover ? 10 : 0"
                                outlined
                                height="200"
                                class="d-flex justify-center align-center"
                                @click="clickportraitImage"
                                >
                                    <img
                                    v-if="portraitFilePath != null"
                                    full
                                    :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + portraitFilePath.replace('files/', '/')" class="mt-2 mb-2" style="height: 180px">
                                    
                                    <div
                                    v-else>
                                        등록된 이미지가 없습니다.
                                    </div>   
                            </v-card>
                        </v-hover>
                </v-col>
                <v-col>
                    <div
                        class="d-flex flex-row align-center">
                        <v-file-input
                            :rules="rules"
                            v-model="files.appLandscapeFileId"
                            :disabled="landscapeFilePath != null"
                            accept="image/png, image/jpeg, image/bmp"
                            placeholder="가로광고 이미지 파일을 선택하여 주십시오"
                            prepend-icon="mdi-file-image"
                            label="가로광고(전면/중간)"
                        ></v-file-input>
                            <v-btn
                                small
                                :disabled="landscapeFilePath != null || files.appLandscapeFileId == null"
                                color="blue"
                                @click="clickUploadImageBtn('appLandscapeFileId')"
                                class="ml-3">
                                업로드
                            </v-btn>
                            <v-btn
                                small
                                :disabled="landscapeFilePath == null"
                                color="red"
                                @click="clickDeleteImageBtn('appLandscapeFileId')"
                                class="ml-3">
                                삭제
                            </v-btn>
                    </div>
                        <v-hover
                            v-slot="{ hover }"
                            :disabled="landscapeFilePath == null"
                        >
                            <v-card
                                :class="{ 'on-hover': hover }"
                                :elevation="hover ? 10 : 0"
                                outlined
                                height="200"
                                class="d-flex justify-center align-center"
                                @click="clicklandscapeImage"
                                >
                                    <img
                                    v-if="landscapeFilePath != null"
                                    full
                                    :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + landscapeFilePath.replace('files/', '/')" class="mt-2 mb-2" style="height: 180px">
                                    
                                    <div
                                    v-else>
                                        등록된 이미지가 없습니다.
                                    </div>   
                            </v-card>
                        </v-hover>
                </v-col>
            </v-row>
            <div class="py-2"></div>
            <v-btn
            class="mr-4"
            color="blue"
            :disabled="appName?appPackage?appVersion?false:true:true:true"
            @click="dialog = true"
            >
            {{queryAppId?'수정':'등록'}}
            </v-btn>

            <v-btn to="/advertisement_list">
            취소
            </v-btn>
        </form>
    </v-card>
        <div class="py-3"></div>
        <v-dialog
            v-model="iconDialog"
            width="512"
            >
            <v-img
                v-if="iconFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + iconFilePath.replace('files/', '/')"
                style="height: 512px; width:512px;"
            ></v-img>
        </v-dialog>
        <v-dialog
            v-model="graphicDialog"
            width="1024"
            >
            <v-img
                v-if="graphicFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + graphicFilePath.replace('files/', '/')"
                style="height: 500px; width:1024px;"
            ></v-img>
        </v-dialog>
        <v-dialog
            v-model="landscapeDialog"
            width="1280"
            >
            <v-img
                v-if="landscapeFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + landscapeFilePath.replace('files/', '/')"
                style="height: 720px; width:1280px;"
            ></v-img>
        </v-dialog>
        <v-dialog
            v-model="noticeDialog"
            width="512"
            >
            <v-img
                v-if="noticeFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + noticeFilePath.replace('files/', '/')"
                style="height: 512px; width:512px;"
            ></v-img>
        </v-dialog>
        <v-dialog
            v-model="portraitDialog"
            width="720"
            >
            <v-img
                v-if="portraitFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + portraitFilePath.replace('files/', '/')"
                style="height: 1280px; width:720px;"
            ></v-img>
        </v-dialog>
        <v-snackbar
        v-model="snackbar"
        :vertical="vertical"
        >
        {{ text }}
        </v-snackbar>
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          기본정보 확인
        </v-card-title>

        <v-card-text>
            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                    <th class="text-left">
                        항목
                    </th>
                    <th class="text-left">
                        내용
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td>{{ '언어' }}</td>
                    <td>{{ langeageForWatch }}</td>
                    </tr>
                    <tr>
                    <td>{{ '운영체제' }}</td>
                    <td>{{ osForWatch }}</td>
                    </tr>
                    <tr>
                    <td>{{ '게임명' }}</td>
                    <td>{{ appName }}</td>
                    </tr>
                    <tr>
                    <td>{{ '페키지' }}</td>
                    <td>{{ appPackage }}</td>
                    </tr>
                    <tr>
                    <td>{{ '버전' }}</td>
                    <td>{{ appVersion }}</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            취소
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="clickDialogSubmitBtn"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div> 
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
import router from '../../router';
export default {
    name: 'UserList',

    data: () => ({
        rules: [
            value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
        ],
        // 파이의 업로드를 위한 파일을 formdata에 보내주기 위한 변수
        files:{
            appNoticeFileId:null,
            appIconFileId:null,
            appGraphicFileId:null,
            appPortraitFileId:null,
            appLandscapeFileId:null
        },
        dialog:false,
        text:'',
        snackbar:false,
        vertical: true,
        iconDialog:false,
        graphicDialog:false,
        landscapeDialog:false,
        noticeDialog:false,
        portraitDialog:false,
        checkbox:'',
        menu: false,
        menu2:false,
        date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date2:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        menut1: false,
        menut2:false,
        time:"",
        time1:"",
        time2:"",
        appInfo:"",
        queryAppId:"",
        regFlag:"",
        orderNo:'',
        appId:null,
        appName:'',
        appBrand:'',
        appOs:'',
        appPackage:'',
        appAppleId:'',
        urlSchemes:'',
        appVersion:'',
        appCustomLink:'N',
        appCustomUrl:'',
        appReservation:'N',
        appReservationUrl:'',
        appNotice:'N',
        appUseFlag:'N',
        appFirstOrder:'',
        appRepeatCount:'',
        // apps_info에 저장되어있는 files의 파일정보의 id
        appNoticeFileId:'',
        appIconFileId:'',
        appGraphicFileId:'',
        appPortraitFileId:'',
        appLandscapeFileId:'',
        appRegDate:'',
        graphicFilePath:null,
        iconFilePath:null,
        landscapeFilePath:null,
        noticeFilePath:null,
        portraitFilePath:null,
        search:'',
        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        headers: [            
           { text: '아이콘', value: 'icon', sortable: false, width:150 },
            { text: '게임명', value: 'game_name', width:200 },
            { text: '패키지', value: 'package' },
            { text: '개시', value: 'initiate', width:80},
            { text: '광고설정', value: 'config', sortable: false, width:300 },
            { text: '수정', value: 'actions', sortable: false, width:116 }
        ],
        event_history_all:[  
            {
                icon:"https://day7adimageserver.s3.ap-northeast-2.amazonaws.com/2022-01-05/20220105115604109_2.png",
                game_name:'바지사장',
                package:'com.newday.pantsce',
                initiate: false,
                config:{
                    전면광고: false,
                    중간광고: true,
                    우선노출: false,
                    메인앱: true,
                    종료팝업: false,
                    반복노출수: 3,
                }
            },
            {
                icon:"https://day7adimageserver.s3.ap-northeast-2.amazonaws.com/2022-01-05/20220105115604109_2.png",
                game_name:'(AD)오피스 스캔들 ~ 연애, 일, 그리고 사건 ~',
                package:'com.com2us.storypick.android.google.global.normal.storypick12',
                initiate: false,
                config:{
                    전면광고: false,
                    중간광고: true,
                    우선노출: false,
                    메인앱: true,
                    종료팝업: false,
                    반복노출수: 2,
                }
            },
            {
                icon:"https://day7adimageserver.s3.ap-northeast-2.amazonaws.com/2022-01-05/20220105115604109_2.png",
                game_name:'바지사장',
                package:'com.newday.pantsce',
                initiate: true,
                config:{
                    전면광고: false,
                    중간광고: true,
                    우선노출: false,
                    메인앱: true,
                    종료팝업: false,
                    반복노출수: 1,
                }
            },           
        ]
    }),

    created()
    {
        //this.end_date = moment().add(1,'M').format('yyyy-MM-DD');
        this.start_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.end_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.OnSearch_Event();
        console.log('created 실행됨')
        console.log(store.state.selected_ad_os)
        this.appOs = this.set_ad_os()
        // 쿼리 관련 내용
        // 변경 또는 생성되었을 시에 쿼리를 넘겨주어서 그 쿼리를 받아서 스낵바ㅡㄹ 보여주는 로직을 만들어야 ㅎ나다.
        if (this.$route.query.appId){
            if(this.$route.query.uORc){
                if(this.$route.query.uORc == 'U'){
                    this.text = '광고 정보가 수정되었습니다.'
                    this.snackbar = true
                } else if(this.$route.query.uORc == 'C') {
                    this.text = '광고가 등록되었습니다.'
                    this.snackbar = true
                }
            }
            this.queryAppId = this.$route.query.appId;
            this.getAppInfo()
        }
        console.log('받아온 쿼리 아이디',this.queryAppId);
    },
    methods:{
        ...mapActions([
            'GET_LOG_TODAY',
            'GET_LOG',
            'GET_APP_INFO',
            'UPLOAD_DELETE_FILE',
            'UPDATE_CERATE_APPS_INFO'
        ]),
        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
         OnSearch_Event()
        {
            /*

            */
        },
        OnSearch_Event_Today()
        {//오늘자로만 검색해서 가져오도록 한다                              
            let log_type = 'REGIST';
            this.event_history_all = [];
            console.log(log_type);
            this.GET_LOG_TODAY({log_type}).then((body_data)=>{
                console.log("ADD_LOG_EVENT"+JSON.stringify(body_data));
                
                let event_info = body_data.event_info;
                let remake_eventInfo ={};// event_info[]
                for(let index in event_info)
                {   
                    remake_eventInfo[event_info[index].event_tag] = event_info[index];
                }
                console.log(JSON.stringify(remake_eventInfo));
                let result = body_data.result;
                for(let index in result)
                {
                    let reportItem = result[index];
                    let eventInfo = remake_eventInfo[reportItem.event_tag];
                    if(eventInfo != undefined)
                    {
                        let event_item = {};
                        event_item['event_tag'] = eventInfo.event_tag;
                        event_item['event_name'] = eventInfo.event_name;
                        event_item['package'] = eventInfo.package;
                        event_item['count'] = reportItem.count;
                        
                        this.event_history_all.push(event_item);
                        console.log(JSON.stringify(reportItem));
                    }
                }
                console.log(JSON.stringify(this.event_history_all));
            });
        },
        DownloadData_Csv()
        {
            console.log('이벤트 다운로드 하기 ');
        },
        editItem()
        {
            alert('데이터 수정 클릭됨')
        },
        set_ad_os(){
            return store.state.selected_ad_os
        },
        submit(){
            console.log('submit 실행됨')
        },
        clear(){
            console.log('clear 실행됨')
        },
        clickIconImage(){
            this.iconDialog = true
        },
        clickgraphicImage(){
            this.graphicDialog = true
        },
        clicklandscapeImage(){
            this.landscapeDialog = true
        },
        clicknoticeImage(){
            this.noticeDialog = true
        },
        clickportraitImage(){
            this.portraitDialog = true
        },
        fileIdSelecter(fileType){
            let fieId;
            switch(fileType) {
            case 'appNoticeFileId':
                fieId = this.appNoticeFileId;
                break;
            case 'appIconFileId' :
                fieId = this.appIconFileId;
                break; 
            case 'appGraphicFileId' :
                fieId = this.appGraphicFileId;
                break;
            case 'appPortraitFileId' :
                fieId = this.appPortraitFileId;
                break;
            case 'appLandscapeFileId' :
                fieId = this.appLandscapeFileId;
                break;
            }
            return fieId;
        },
        // 확인 다이어로그에서  확인을 눌렀을 경우에 실행된는 함수
        // 수정 필요
        async clickDialogSubmitBtn(){
            console.log('다이어로그 확인 버튼 클릭됨')
            // os정보와 언어 정보는 localstorage에서 받아서 온다.
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            // 앱아이디는 쿼리에서 받아온다.
            const appId = this.queryAppId
            // 요청에 필요로 되는 파라미터들을 선언 한 후에 바인딩된 내용들을 대입시켜준다.
            const appName = this.appName
            const appPackage = this.appPackage
            const appAppleId = this.appAppleId
            const urlSchemes = this.urlSchemes
            const appVersion = this.appVersion
            const appCustomLink = this.appCustomLink
            const appCustomUrl = this.appCustomUrl
            const appReservation = this.appReservation
            const appReservationUrl = this.appReservationUrl
            const appNotice = this.appNotice
            const appNoticeStartDate = this.appNoticeStartDate
            const appNoticeEndDate = this.appNoticeEndDate
            const appUseFlag = this.appUseFlag
            const appNoticeFileId = this.appNoticeFileId
            const appIconFileId = this.appIconFileId
            const appGraphicFileId = this.appGraphicFileId
            const appPortraitFileId = this.appPortraitFileId
            const appLandscapeFileId = this.appLandscapeFileId

            // 업로드 또는 생성이 완료된 경우에는 appId를 돌려받는다.
            const updateOrCreateResult = await this.UPDATE_CERATE_APPS_INFO({selected_ad_os,selected_ad_language,appId,
            // 위의 내용 이외에도 넣어주어야 하는 내용 -> 생성 쿼리에서 필요한 내용들
            // orderNo -> 서버사이드에서 디비를 select하여 넣어준다.
            appName,
            // appBrand -> 서버사이드에서 하드코딩한다.
            appPackage,
            appAppleId,
            urlSchemes,
            appVersion,
            appCustomLink,
            appCustomUrl,
            appReservation,
            appReservationUrl,
            appNotice,
            appNoticeStartDate,
            appNoticeEndDate,
            appUseFlag,
            // 우선노출과 반복횟수는 등록 및 수정페이지에서는 조작되지 않는다. 생성인 경우에는 산출하여 넣어주고 업데이트인 경우에는 업데이트를 진행하지 않는다.
            //appFirstOrder,
            //appRepeatCount,
            appNoticeFileId,
            appIconFileId,
            appGraphicFileId,
            appPortraitFileId,
            appLandscapeFileId
            })

            console.log(updateOrCreateResult)

            // 다이어로그를 없앤다.
            this.dialog = false

            /*
            // 응답객체에서 받아서 오는 app id를 getAppInfo 메서드에서 사용하게 되는 queryAppId에 넣어준다.
            this.queryAppId = updateOrCreateResult.responseAppId
            // 받은 appId를 사용하여서 정보를 가져와서 폼을 채워준다. queryAppId가 들어가기 때문에 광고수정으로 표시가 된다.
            this.getAppInfo()
            */

            // 이동시에 쿼리로 appId와 생성인지 업데이트인지의 여부를 함께 보내준다. 
            this.$router.push(`/advertisement_regist?appId=${updateOrCreateResult.responseAppId}&uORc=${updateOrCreateResult.uORc}`).catch(()=>{this.$router.go()})

        },
        async clickUploadImageBtn(fileT){
            console.log('업로드 버튼 클릭됨')
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            const appId = this.queryAppId
            const fileType = fileT
            const uploadOrDelete = 'U'
            const file = this.files[fileT]
            // 이미지 삭제를 위하여 fileId를 추가하였다.
            const fileId = null
            const uploadResult = await this.UPLOAD_DELETE_FILE({selected_ad_os,selected_ad_language,appId,fileType,uploadOrDelete,file,fileId})
            console.log(uploadResult)

            switch (uploadResult.fileType) {
            case "appNoticeFileId":
                this.noticeFilePath = uploadResult.imgPath;
                this.appNoticeFileId = uploadResult.fileId;
            break;
            case "appIconFileId":
                this.iconFilePath = uploadResult.imgPath;
                this.appIconFileId = uploadResult.fileId;
            break;
            case "appGraphicFileId":
                this.graphicFilePath = uploadResult.imgPath;
                this.appGraphicFileId = uploadResult.fileId;
            break;
            case "appPortraitFileId":
                this.portraitFilePath = uploadResult.imgPath;
                this.appPortraitFileId = uploadResult.fileId;
            break;
            case "appLandscapeFileId":
                this.landscapeFilePath = uploadResult.imgPath;
                this.appLandscapeFileId = uploadResult.fileId;
            break;
            default:
            break;
            }
            this.text = '사진이 업로드 되었습니다.'
            this.snackbar = true
            // 이후 응답을 이용하여서, 프론트엔드에 반영시킨다.
            // 데이터 리프레시가 어려운 이유는, 새로 광고를 등록시킬 시에는 리프레시 할 시에 키워드가 될 appId가 존재하지 않기 때문이다.
        },
        async clickDeleteImageBtn(fileT){
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            const appId = this.queryAppId
            const fileType = fileT
            const uploadOrDelete = 'D'
            const file = null
            // 파일 삭제를 위하여 fileId를 삭제하였다. 해당되는 filetype의 fileId를 가져와서 넣어주어야 한다.
            const fileId = this.fileIdSelecter(fileT)
            const deleteResult = await this.UPLOAD_DELETE_FILE({selected_ad_os,selected_ad_language,appId,fileType,uploadOrDelete,file,fileId})
            console.log(deleteResult)
            // 이후 응답을 이용하여서, 프론트엔드에 반영시킨다. 삭제시킨다.

            // 요청이 들어간 이미지 종류에 따라서 path를 null로 변경시킨다.
            switch (deleteResult.fileType) {
            case "appNoticeFileId":
                this.noticeFilePath = null;
                this.appNoticeFileId = null;
            break;
            case "appIconFileId":
                this.iconFilePath = null;
                this.appIconFileId = null;
            break;
            case "appGraphicFileId":
                this.graphicFilePath = null;
                this.appGraphicFileId = null;
            break;
            case "appPortraitFileId":
                this.portraitFilePath = null;
                this.appPortraitFileId = null;
            break;
            case "appLandscapeFileId":
                this.landscapeFilePath = null;
                this.appLandscapeFileId = null;
            break;
            default:
            break;
            }
            this.text = '이미지가 삭제되었습니다.'
            this.snackbar = true
        },
        async getAppInfo(){
            // 파라미터가 있는 경우, 해당 파라미터의 아이디를 요청으로 보내서 apps_info의 데이터를 가져오는 요청을 진행 한 후에, 가가각의 데이터를 폼에다가 넣어주는 작업을 진행한다.
            if(this.queryAppId != ''){
                console.log('appInfo 가져오기 실행됨')
                const selected_ad_os = this.osForWatch
                const selected_ad_language = this.langeageForWatch
                const appId = this.queryAppId
                this.appInfo = await this.GET_APP_INFO({selected_ad_os,selected_ad_language,appId})
                console.log(this.appInfo)
                // 아래에는 가져온 데이터를 폼에 집어넣는 로직이 들어가게 된다.
                this.appId = this.appInfo.appId
                this.appName = this.appInfo.appName
                this.appBrand = this.appInfo.appBrand
                this.appOs = this.appInfo.appOs
                this.appPackage = this.appInfo.appPackage
                this.appAppleId = this.appInfo.appAppleId
                this.appAppleId = this.appInfo.appAppleId 
                this.urlSchemes = this.appInfo.urlSchemes 
                this.appVersion = this.appInfo.appVersion
                this.appCustomLink = this.appInfo.appCustomLink
                this.appCustomUrl = this.appInfo.appCustomUrl
                this.appReservation = this.appInfo.appReservation
                this.appReservationUrl = this.appInfo.appReservationUrl
                this.appNotice = this.appInfo.appNotice
                this.appUseFlag = this.appInfo.appUseFlag
                this.appFirstOrder = this.appInfo.appFirstOrder
                this.appRepeatCount = this.appInfo.appRepeatCount
                this.appNoticeFileId = this.appInfo.appNoticeFileId
                this.appIconFileId = this.appInfo.appIconFileId
                this.appGraphicFileId = this.appInfo.appGraphicFileId
                this.appPortraitFileId = this.appInfo.appPortraitFileId
                this.appLandscapeFileId = this.appInfo.appLandscapeFileId
                this.appRegDate = this.appInfo.appRegDate
                // 표시를 위하여 가공된 이미지파일 저장 루트
                this.graphicFilePath = this.appInfo.graphicFilePath
                this.iconFilePath = this.appInfo.iconFilePath
                this.landscapeFilePath = this.appInfo.landscapeFilePath
                this.noticeFilePath = this.appInfo.noticeFilePath
                this.portraitFilePath = this.appInfo.portraitFilePath

                // appNoticeDaate와 appNoticeEndDate를 분할하여서 각각의 date1, date2와 time1과 time2에 대입하여서 넣어주는 로직이 필요하게 된다.
                /*
                    현제는 정보를 가져오는 메서드가 실행이 되면은 appNoticeStartDateArr, appNoticeStartDateArr 에 데이터베이스의 정보를 대입시킨 후
                    가져온 데이터를 가공을 진행하여서 입력부에 bind된 변수에 넣어준다.
                    들어간 내용들은 유저에게 표시되지만, 유저가 입력한 내용은 요청시에 보내게될 폼에 자동으로 바인딩 되지 않는다.
                    따라서, 데이터를 가져올 시에는 appNoticeStartDateArr와 appNoticeStartDateArr에는 대입을 진행하지 않고, 
                    응답객체의 정보를 바로 가공하여서 각각의 time, date에 넣어준다, 그 후  
                    appNoticeStartDateArr와 appNoticeStartDateArr에는 time과 date에서 computed된 내용을 넣어준다.
                */
                this. appNoticeStartDateArr = this.appInfo.appNoticeStartDate.split(' ')
                this.date = this.appNoticeStartDateArr[0]
                this.time1 = this.appNoticeStartDateArr[1]
                this. appNoticeEndDateArr = this.appInfo.appNoticeEndDate.split(' ')
                this.date2 = this.appNoticeEndDateArr[0]
                this.time2 = this.appNoticeEndDateArr[1]
            }
        }
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : ''
        },
        selected_ad_os(){
            return store.state.selected_ad_os
        },
        osForWatch () {
            return store.state.selected_ad_os
        },
        langeageForWatch () {
            return store.state.selected_ad_language
        },
        // 정보등록 및 정보수정에 들어갈 폼에 들어가는 공지사항의 시간 정보
        appNoticeStartDate () {
            return `${this.date} ${this.time1}`
        },
        appNoticeEndDate () {
            return `${this.date2} ${this.time2}`
        },
    },
    watch :{
        osForWatch: function() {
            // 광고등록 페이지로 단순히 이동하는 로직
            this.$router.push('/advertisement_regist')
        },
        langeageForWatch: function() {
            // 광고등록 페이지로 단순히 이동하는 로직
            this.$router.push('/advertisement_regist')
        },
    },
    components:{
    },

}
</script>
